import { render, staticRenderFns } from "./standard_dialog.vue?vue&type=template&id=b555f678&scoped=true"
import script from "./standard_dialog.vue?vue&type=script&lang=js"
export * from "./standard_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b555f678",
  null
  
)

export default component.exports